import { useEffect, useState } from 'react'
import { WeaverLoading } from 'Components'
import withDetailsContainer from './withDetailsContainer'
import { getProjectData, getAttributeKeyLabel, getMemberKey, getNodeLabel, getRelationkeyLabel } from 'Services/WeaverUtils'
import { Tooltip, Input } from 'antd'
import { EditOutlined, CheckOutlined } from '@ant-design/icons'
import { relationAttributesRenderer } from './shared'

export default RelationDetails = ({ data }) ->
  [item, setItem] = useState(undefined)
  [loading, setLoading] = useState(true)

  useEffect( ->
    ( ->
      setLoading(true)
      if data.relation.graph?
        q = new Weaver.Query()
          .restrict([data.relation.id()])
          .inGraph(data.relation.graph)
          .withRelations()
          .selectOut(getMemberKey())
      else
        q = new Weaver.Query()
          .restrict([data.relation.id()])
          .withRelations()
          .selectOut(getMemberKey())

      (getProjectData().relationAttributes or [])
        .map(({ relKey }) ->
          q.selectOut(relKey, getMemberKey())
        )

      relNode = await q.first()
      { fromNode, toNode } = data.relation

      setItem(Object.assign(relNode, { fromNode, toNode }))
      setLoading(false)
    )()
    undefined
  , [data])

  changeKey = (newKey) ->
    { fromNode, key } = data.relation
    fromNode.changeRelationKey(key, newKey)
    fromNode.save()

  return <WeaverLoading style={{ margin: '33%' }} /> if loading
  Details = withDetailsContainer(item, { nodeIsEditable: true })

  RelationInput = ({ updateValue, attributeKey, receivedProps... }) ->
    [updatedValue, setUpdatedValue] = useState(receivedProps.value)

    <Input
      node={data.relation.fromNode}
      value={updatedValue}
      className="inline-node-editor-input-field"
      data-testid="inline-node-editor-input-field-#{ attributeKey }"
      size='small'
      onChange={(val) ->
        val?.target?.value? && val = val.target.value
        setUpdatedValue(val)
        updateValue(val)
      }
    />

  <Details>
    {[
      _.chain(item.attributes())
        .map((val, key) ->
          {
            key,
            label: <Tooltip title={key}>{ _.truncate(getAttributeKeyLabel(key), { length: 25 }) }</Tooltip>
            value: val
          }
        ).sortBy('key')
      .value()...
      {
        key: 'from'
        label: 'From'
        value: getNodeLabel(item.fromNode)
        rowIsEditable: false
      }, {
        key: 'to'
        label: 'To'
        value: getNodeLabel(item.toNode)
        rowIsEditable: false
      }, {
        key: 'key'
        label: 'Key'
        value: getRelationkeyLabel(item.key, item.nodeId)
        InputField: RelationInput
        saveChangesFn: changeKey
      }, relationAttributesRenderer(item)...
    ]}
  </Details>
